import { render, staticRenderFns } from "./custom_detail.vue?vue&type=template&id=628141fc&scoped=true"
import script from "./custom_detail.vue?vue&type=script&lang=js"
export * from "./custom_detail.vue?vue&type=script&lang=js"
import style0 from "./custom_detail.vue?vue&type=style&index=0&id=628141fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628141fc",
  null
  
)

export default component.exports